import api from "../../infra/api";

class ServSolicitacaoFiscalizacaoDocs {
  async listar(codigoSolicFiscalizacao) {
    const response = await api({
      method: "GET",
      url: `/api/v1/SFDocs?page=1&start=0&limit=999&fields=["Id","CodigoSolicitacaoFiscalizacao","CodigoDocumento","NomeArquivo","TipoDocumento","CodigoConfiguracaoDoc","CodigoClassificacaoDoc","Aprovado"]&sort=[{"property":"CodigoDocumento","direction":"DESC"}]&filter=[{"property":"CodigoSolicitacaoFiscalizacao","value":"${codigoSolicFiscalizacao}","and":false}]`
    });

    return response.data;
  }

  async AdicionaranexoSolicFiscalizacao(form) {
    const response = await api({
      method: "POST",
      url: "/api/v1/SFDocs",
      headers: {
        "Content-Type": "multipart/form-data",
      },
      data: form
    });

    return response.data;
  }

  async RealizarDownloadDocumento(codigoFiscalizacaoDocs) {
    const response = await api({
      method: "GET",
      url: `api/v1/SFDocs/RealizarDownloadDocumento/${codigoFiscalizacaoDocs}`
    });

    return response.data;
  }

  async RemoverAnexoFiscalizacao(codigoFiscalizacaoDoc) {
    const response = await api({
      method: "DELETE",
      url: `api/v1/SFDocs/RemoverDocumento/${codigoFiscalizacaoDoc}`
    });

    return response.data;
  }
}

export default new ServSolicitacaoFiscalizacaoDocs();